import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7cc7a52b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7cc7a52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc7a52b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc7a52b')) {
      api.createRecord('7cc7a52b', component.options)
    } else {
      api.reload('7cc7a52b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7cc7a52b&scoped=true&", function () {
      api.rerender('7cc7a52b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/bank-account-change/index.vue"
export default component.exports